import axiosConfig from "./axiosConfig";

export interface BulkDeleteRequest {
  leadIds: string[];
}

export interface BulkDeleteResponse {
  deleted: number;
  requested: number;
}

const postLeadBulkDelete = async (
  authToken: string,
  body: BulkDeleteRequest
): Promise<BulkDeleteResponse> => {
  const { data } = await axiosConfig.post(`/leads/bulk-delete`, body, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default postLeadBulkDelete;
